<!--
 * @Author: yaoyuting
 * @Date: 2020-03-20 19:30:58
 * @LastEditors: 徐艳龙 w17630400757@163.com
 * @LastEditTime: 2022-06-06 09:00:19
 * @Descripttion:
-->
<template>
  <div class="foot">
    <div class="footer-W">
      <div class="footer_tit">Contact Us</div>
      <div class="footer_cont">
        <div class="footer_contl">
          <a
            data-testid="linkElement"
            href="mailto:contact@uqc.world"
            target="__black"
          >
            <img
              class="footer_img1"
              src="../../assets/pc/uqcindex/footer1.png"
            />
          </a>
          <a href="https://twitter.com/UQC_VC" target="__black">
            <img
              class="footer_img2"
              src="../../assets/pc/uqcindex/footer2.png"
            />
          </a>
        </div>
        <div class="footer_contr">
          <!-- <a href="#" class="txt"> Raindrop Digital </a>
         
            <img class="imga" src="@/assets/pc/indexpic/ios.png"
          />
      
          <a href="http://www.uqc.world/apk/Tick-Wallet.apk">
            <img class="imgb" src="@/assets/pc/indexpic/adr.png"
          /></a> -->
        </div>
      </div>
      <div class="footer_btm">
        <div class="footer_l"></div>
        <div class="footer_r">Copyright © UQC</div>
      </div>
    </div>
  </div>
</template>

<script>
import { GetEmail } from "@/assets/server/api.js";
export default {
  data() {
    return {
      ruleForm: { email: "" },
      rules: {
        email: [
          {
            required: true,
            type: "email",
            // message: "Please input email",
            trigger: "blur",
          },
        ],
      },
      W: document.body.clientWidth + "px",
    };
  },
  created() {
    // this.$bus.$emit("goAuchor", "#one");
  },
  methods: {
    Push(index) {},
    async submitForm(formName) {
      var regEmail =
        /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
      if (formName != "") {
        if (formName != "" && !regEmail.test(formName)) {
          this.$message({
            message: "Email must be formatted correctly",
            type: "error",
          });
          this.ruleForm.email = "";
        } else {
          let formData = new FormData();
          let params = {
            email: this.ruleForm.email,
          };
          console.log("params", params);
          let item = params;
          for (const key in item) {
            if (Object.hasOwnProperty.call(item, key)) {
              formData.append(key, item[key]);
            }
          }
          console.log(formData);
          let data = await GetEmail(formData);
          this.$message({
            showClose: true,
            message: "Mailbox subscription succeeded",
            type: "success",
          });
          this.ruleForm.email = "";
        }
      } else {
        this.$message({
          message: "Please enter your e-mail address",
          type: "error",
        });
      }

      // this.$refs[formName].validate((valid) => {
      //   console.log(valid);
      //   if (valid) {
      //     alert("submit!");
      //   } else {
      //     console.log("error submit!!");
      //     return false;
      //   }
      // });
    },
    Masg() {
      this.$message("Coming Soon");
    },
  },
};
</script>

<style lang="less" scoped>
.foot {
  width: 100%;
  height: 145px;
  background: #2f47ee;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
}
.footer-W {
  width: 1320px;
  margin: 0 auto;
  background: #2f47ee;
  .footer_tit {
    // border: 1px solid red;
    height: 64px;
    font-size: 16px;
    font-family: Poppins-Medium, Poppins;
    font-weight: 500;
    color: #ffffff;
    line-height: 64px;
  }
  .footer_cont {
    width: 1320px;
    height: 30px;
    // margin-top: 58px;
    display: flex;
    justify-content: space-between;
    .footer_contl {
      .footer_img1 {
        width: 20px;
        height: 14px;
        margin-top: 2px;
        margin-right: 18px;
        margin-left: 10px;
      }
      .footer_img2 {
        width: 21px;
        height: 18px;
      }
    }
    .footer_contr {
      .txt {
        height: 19px;
        font-size: 16px;
        font-family: Roboto-Regular, Roboto;
        font-weight: 400;
        color: #ffffff;
        line-height: 19px;
        margin-right: 13px;
        margin-top: 4px;
      }
      .imga {
        width: 16px;
        height: 20px;
        margin-right: 15px;
      }
      .imgb {
        width: 17px;
        height: 20px;
      }
    }

    // img {
    //   width: 20px;
    //   height: 14px;
    //   margin-right: 18px;
    // }
  }
  .footer_btm {
    display: flex;
    //margin-top: 51px;
    .footer_l {
      width: 1168px;
      height: 0px;
      opacity: 1;
      margin-top: 30px;
      border: 1px solid #ffffff;
    }
    .footer_r {
      width: 138px;
      height: 24px;
      font-size: 16px;
      font-family: Poppins-Medium, Poppins;
      font-weight: 500;
      color: #ffffff;
      line-height: 24px;
      margin-top: 12px;
      margin-left: 6px;
    }
  }
}
</style>
